<template>
  <div class="overlay">
    <div class="dialog">
      <div class="dialog__header">
        <slot name="dialog-header"></slot>
      </div>
      <div class="dialog__content">
        <slot name="dialog-content"></slot>
      </div>
      <div class="dialog__footer">
        <div class="btn btn-primary" @click="closeDialog">OK</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "custom-dialog",
  emits: ["close-dialog"],
  methods: {
    closeDialog() {
      this.$emit('close-dialog');
    }
  }
}
</script>

<style scoped lang="scss">
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  background: rgba(#000, .6);
  z-index: 999;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.dialog {
  max-height: 100%;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  @include md {
    min-width: 550px;
    max-width: 750px;
  }

  &__header {
    width: 100%;
    padding: 2rem 2rem 0 2rem;
  }
  &__content {
    width: 100%;
    padding: 2rem;
    color: rgba(#333, .6);
  }
  &__footer {
    width: 100%;
    padding: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    .btn {
      @include lg {
        line-height: 1rem;
        min-height: auto;
      }
    }
  }
}
</style>
